import { FC, useMemo, useCallback } from 'react'
import styles from 'components/features/pfm/SubscriptionPane/SubscriptionPanePreset.styl'
import Button from 'components/features/pfm/Button/Button'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { CANCEL_BUTTON_PROPS, KillAllPanesButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import { SubscriptionPanePreset } from 'components/features/pfm/SubscriptionPane/SubscriptionPanePreset'

export const SubscriptionWelcomePane: FC<{}> = () => {

  const dispatch = useStoreDispatch()
  const handleNextStep = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator('subscription', {
      mode: 'new-payment',
    }))
  }, [dispatch])

  const nextButtonChild = useMemo(() => (
    <Button
      text='Go Premium Now'
      qaMarker='save-button'
      onClick={ handleNextStep }
    />
  ), [handleNextStep])

  const cancelButtonChild = useMemo(() => (
    <KillAllPanesButton { ...CANCEL_BUTTON_PROPS } text='Maybe Later' />
  ), [])

  return useMemo(() => (
    <SubscriptionPanePreset
      title={ <>Welcome to<br />Premium</> }
      subTitle='Manage your money with confidence - and meet with a certified coach every month!'
      primaryButton={ nextButtonChild }
      cancelButton={ cancelButtonChild }
    >
      <div className={ styles.imageWrapper } />
      <div className={ styles.content }>
        <div className={ styles.title }>
          Unlock One-on-One<br />
          Coaching and More...
        </div>
        <div className={ styles.item }>
          <b className={ styles.bold }>Analyze your finances</b> with beautiful charts
        </div>

        <div className={ styles.item }>
          <b className={ styles.bold }>Plan your future</b> by setting goals
        </div>

        <div className={ styles.item }>
          <b className={ styles.bold }>Get your Credit report</b>, updated weekly
        </div>

        <div className={ styles.item }>
          <b className={ styles.bold }>Customize your peer groups</b> and filters
        </div>
      </div>
    </SubscriptionPanePreset>
  ), [cancelButtonChild, nextButtonChild])
}
